import { render, staticRenderFns } from "./ChatConversationPanel.vue?vue&type=template&id=63e8606d&scoped=true"
import script from "./ChatConversationPanel.vue?vue&type=script&lang=js"
export * from "./ChatConversationPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatConversationPanel.vue?vue&type=style&index=0&id=63e8606d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e8606d",
  null
  
)

export default component.exports